module.exports = __webpack_public_path__ + "static/media/gov-2.e80faeba.png";